// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.splash-screen {
  position: fixed;
  inset: 0;
  background-color: #020617;
  background-image: radial-gradient(circle at center, #0f172a 0%, #020617 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  overflow: hidden;
}

.splash-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
  z-index: 10;
}

.splash-logo-container {
  position: relative;
  width: 140px;
  height: 140px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.splash-logo-img {
  width: 120px;
  height: 120px;
  object-fit: contain;
  z-index: 2;
  filter: drop-shadow(0 0 20px rgba(153, 27, 27, 0.4));
}

.meci-glow {
  position: absolute;
  width: 120px;
  height: 120px;
  background-color: var(--brand-primary);
  filter: blur(60px);
  opacity: 0.5;
  border-radius: 50%;
  animation: pulse-glow 4s infinite alternate;
}

.splash-text-area {
  text-align: center;
}

.splash-brand-title {
  font-size: 32px;
  font-weight: 900;
  color: white;
  letter-spacing: 12px;
  margin-left: 12px;
  margin-bottom: 8px;
}

.splash-brand-subtitle {
  font-size: 10px;
  font-weight: 800;
  color: var(--brand-primary);
  letter-spacing: 4px;
  opacity: 0.8;
}

.splash-loading-section {
  width: 280px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.splash-progress-track {
  width: 100%;
  height: 2px;
  background-color: rgba(255, 255, 255, 0.05);
  border-radius: 1px;
  overflow: hidden;
}

.splash-progress-bar {
  height: 100%;
  background-color: var(--brand-primary);
  box-shadow: 0 0 10px var(--brand-primary);
}

.splash-loading-status {
  font-size: 11px;
  font-weight: 600;
  color: var(--text-muted);
  letter-spacing: 0.5px;
}

.splash-footer-meta {
  position: absolute;
  bottom: 40px;
  font-size: 11px;
  font-weight: 700;
  color: var(--text-muted);
  opacity: 0.4;
  letter-spacing: 1px;
}

.splash-bg-effects {
  position: absolute;
  inset: 0;
  z-index: 1;
}

.bg-blur-blob {
  position: absolute;
  top: -10%;
  left: -10%;
  width: 40%;
  height: 40%;
  background-color: var(--brand-primary);
  filter: blur(120px);
  opacity: 0.15;
  border-radius: 50%;
  animation: drift 20s infinite alternate;
}

.bg-blur-blob-2 {
  position: absolute;
  bottom: -10%;
  right: -10%;
  width: 50%;
  height: 50%;
  background-color: #1e3a8a;
  filter: blur(150px);
  opacity: 0.1;
  border-radius: 50%;
  animation: drift 25s infinite alternate-reverse;
}

@keyframes pulse-glow {
  from { opacity: 0.3; transform: scale(0.8); }
  to { opacity: 0.6; transform: scale(1.2); }
}

@keyframes drift {
  from { transform: translate(0, 0); }
  to { transform: translate(10%, 10%); }
}
`, "",{"version":3,"sources":["webpack://./src/components/SplashScreen/SplashScreen.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,yBAAyB;EACzB,6EAA6E;EAC7E,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,oDAAoD;AACtD;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,sCAAsC;EACtC,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,WAAW;EACX,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,sCAAsC;EACtC,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,UAAU;EACV,WAAW;EACX,sCAAsC;EACtC,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;EACE,OAAO,YAAY,EAAE,qBAAqB,EAAE;EAC5C,KAAK,YAAY,EAAE,qBAAqB,EAAE;AAC5C;;AAEA;EACE,OAAO,0BAA0B,EAAE;EACnC,KAAK,8BAA8B,EAAE;AACvC","sourcesContent":[".splash-screen {\n  position: fixed;\n  inset: 0;\n  background-color: #020617;\n  background-image: radial-gradient(circle at center, #0f172a 0%, #020617 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10000;\n  overflow: hidden;\n}\n\n.splash-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 40px;\n  z-index: 10;\n}\n\n.splash-logo-container {\n  position: relative;\n  width: 140px;\n  height: 140px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.splash-logo-img {\n  width: 120px;\n  height: 120px;\n  object-fit: contain;\n  z-index: 2;\n  filter: drop-shadow(0 0 20px rgba(153, 27, 27, 0.4));\n}\n\n.meci-glow {\n  position: absolute;\n  width: 120px;\n  height: 120px;\n  background-color: var(--brand-primary);\n  filter: blur(60px);\n  opacity: 0.5;\n  border-radius: 50%;\n  animation: pulse-glow 4s infinite alternate;\n}\n\n.splash-text-area {\n  text-align: center;\n}\n\n.splash-brand-title {\n  font-size: 32px;\n  font-weight: 900;\n  color: white;\n  letter-spacing: 12px;\n  margin-left: 12px;\n  margin-bottom: 8px;\n}\n\n.splash-brand-subtitle {\n  font-size: 10px;\n  font-weight: 800;\n  color: var(--brand-primary);\n  letter-spacing: 4px;\n  opacity: 0.8;\n}\n\n.splash-loading-section {\n  width: 280px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n}\n\n.splash-progress-track {\n  width: 100%;\n  height: 2px;\n  background-color: rgba(255, 255, 255, 0.05);\n  border-radius: 1px;\n  overflow: hidden;\n}\n\n.splash-progress-bar {\n  height: 100%;\n  background-color: var(--brand-primary);\n  box-shadow: 0 0 10px var(--brand-primary);\n}\n\n.splash-loading-status {\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--text-muted);\n  letter-spacing: 0.5px;\n}\n\n.splash-footer-meta {\n  position: absolute;\n  bottom: 40px;\n  font-size: 11px;\n  font-weight: 700;\n  color: var(--text-muted);\n  opacity: 0.4;\n  letter-spacing: 1px;\n}\n\n.splash-bg-effects {\n  position: absolute;\n  inset: 0;\n  z-index: 1;\n}\n\n.bg-blur-blob {\n  position: absolute;\n  top: -10%;\n  left: -10%;\n  width: 40%;\n  height: 40%;\n  background-color: var(--brand-primary);\n  filter: blur(120px);\n  opacity: 0.15;\n  border-radius: 50%;\n  animation: drift 20s infinite alternate;\n}\n\n.bg-blur-blob-2 {\n  position: absolute;\n  bottom: -10%;\n  right: -10%;\n  width: 50%;\n  height: 50%;\n  background-color: #1e3a8a;\n  filter: blur(150px);\n  opacity: 0.1;\n  border-radius: 50%;\n  animation: drift 25s infinite alternate-reverse;\n}\n\n@keyframes pulse-glow {\n  from { opacity: 0.3; transform: scale(0.8); }\n  to { opacity: 0.6; transform: scale(1.2); }\n}\n\n@keyframes drift {\n  from { transform: translate(0, 0); }\n  to { transform: translate(10%, 10%); }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
